// Shared Recharts palette + formatters used by Reports/Dashboard/ProductDetail.
// Colours resolve to the CSS variables declared in src/index.css so every
// chart picks up the same emerald/amber/violet/blue/cyan scheme.

export const CHART_COLORS = {
  emerald: 'hsl(var(--chart-1))',
  amber:   'hsl(var(--chart-2))',
  violet:  'hsl(var(--chart-3))',
  blue:    'hsl(var(--chart-4))',
  cyan:    'hsl(var(--chart-5))',
  slate:   '#475569',
  rose:    '#e11d48',
} as const

// Recharts CartesianGrid / axis styling - used by every chart so they
// share the same soft grid + muted ticks look.
export const GRID_STROKE = '#e2e8f0'
export const AXIS_TICK = { fill: '#94a3b8', fontSize: 12 }
